import { render, staticRenderFns } from "./postalCode.vue?vue&type=template&id=263e975d&scoped=true&"
import script from "./postalCode.vue?vue&type=script&lang=js&"
export * from "./postalCode.vue?vue&type=script&lang=js&"
import style0 from "./postalCode.vue?vue&type=style&index=0&id=263e975d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e975d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263e975d')) {
      api.createRecord('263e975d', component.options)
    } else {
      api.reload('263e975d', component.options)
    }
    module.hot.accept("./postalCode.vue?vue&type=template&id=263e975d&scoped=true&", function () {
      api.rerender('263e975d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/postalCode.vue"
export default component.exports